import {
    STREAM_WATCHING_ME,
} from '../constants/streaming';

import {
    ROOM_CLIENT_LOGOUT
} from '../constants/users';

function removeEntry(state, entryUfrag) {
    let newState = Object.assign({}, state);
    if (newState.hasOwnProperty(entryUfrag)) delete newState[entryUfrag]

    return newState;
}

export default function watchingMe(state = {}, action) {
    if (action.type == STREAM_WATCHING_ME) {
        if (action.watching) {
            return {
                ...state,
                [action.ufrag]: true
            }
        } else {
            return removeEntry(state, action.ufrag);
        }
    }

    if (action.type == ROOM_CLIENT_LOGOUT) {
        return removeEntry(state, action.user.ufrag);
    }

    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/watchingMe.js